module.exports = __webpack_public_path__ + "static/media/bg.33a3b25c.jpg";